<template>
  <v-app-bar flat :color="getTopBarColor" v-if="showTopBar" app>
    <v-container fluid>
      <v-row align="center" justify="space-between">
        <v-col>
          <div class="ui-module-appbar-title text-h6 font-weight-black w-100">
            {{ $route.matched[0].name
            }}<template
              v-if="
                $route.matched.length > 1 &&
                $route.matched[$route.matched.length - 1].meta &&
                $route.matched[$route.matched.length - 1].meta.pageTitle
              "
            >
              / {{ $route.matched[$route.matched.length - 1].meta.pageTitle }}</template
            >
          </div>
        </v-col>
        <v-col cols="auto">
          <section class="d-flex align-center">
            <v-chip label outlined class="mr-2">v{{ APP_VERSION }}</v-chip>
            <NotificationsMenu />
            <v-card class="ui-module-card" color="primary">
              <v-container>
                <v-row align="center">
                  <v-col cols="1" class="py-1">
                    <v-avatar size="36" v-if="fotoUsuario">
                      <v-img :src="fotoUsuario" :alt="nombre"></v-img>
                    </v-avatar>
                    <v-icon color="secondary" large v-else>mdi-account-circle</v-icon>
                  </v-col>
                  <v-col cols="9" class="py-1 pl-5">
                    <div class="text-subtitle-2 font-weight-bold text--primary text-truncate">{{ nombre }}</div>
                    <div class="text-caption font-weight-bold text--secondary">{{ perfil }}</div>
                  </v-col>
                  <v-col cols="2" class="py-1">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="secondary">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <reset-password-dialog-component></reset-password-dialog-component>
                        <v-list-item v-on:click="triggerLogout()"> Cerrar sesión </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import NotificationsMenu from './notifications/NotificationsMenu.vue'
import { primaryButtonProps } from './props/props'
import ResetPasswordDialogComponent from './ResetPasswordDialogComponent.vue'
import { PERFILES } from '@/perfiles.js'
import redirectToModuleByPerfil from '@/utils/redirectToModuleByPerfil.js'

export default {
  components: {
    ResetPasswordDialogComponent,
    NotificationsMenu,
  },

  data() {
    return {
      PERFILES,
      primaryButtonProps,
    }
  },

  computed: {
    ...mapGetters({
      token: 'getToken',
      nombre: 'getNombre',
      loading: 'getLoader',
      perfil: 'getPerfil',
      idPersonal: 'getIdPersonal',
    }),
    ...mapGetters('personal', {
      loggedUserProfile: 'getLoggedUserProfile',
    }),
    fotoUsuario() {
      const foto = this.loggedUserProfile?.foto
      if (!foto || foto.trim() === '') return null
      return foto
    },

    APP_VERSION: function () {
      return process.env.VUE_APP_VERSION || ''
    },

    showTopBar: function () {
      if (this.loading || this.token.length == 0 || this.$route.name == '404' || this.$route.name == 'Login') {
        return false
      } else return true
    },

    getTopBarColor: function () {
      if (this.$route.name == 'Launcher') {
        return 'transparent'
      } else return 'primary'
    },

    items: function () {
      var items = []
      this.$route.matched.forEach((route) => {
        items.push({
          text: route.name,
        })
      })
      console.log(items)
      return items
    },
  },

  async mounted() {
    if (this.idPersonal) {
      await this.fetchLoggedUserProfile(this.idPersonal)
    }
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('personal', ['fetchLoggedUserProfile']),
    redirectToModuleByPerfil,

    getName: function (name) {
      return name.split(' ', 1)[0]
    },

    triggerLogout: function () {
      this.SET_SNACKBAR_MESSAGE('Cerrando sesión...')
      this.logout()
      window.location.reload()
      // this.$router.replace('/')
    },
  },
}
</script>
